module.exports = __webpack_public_path__ + "static/media/tours-bg.975c09df.png";